import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DvTooltipDirective } from '@devinco/ui/dds';
import { VehicleType } from '@shared/constants/vehicle-type';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-trip-type-setup-header',
  templateUrl: './trip-type-setup-header.component.html',
  imports: [CommonModule, TranslateModule, DvTooltipDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./trip-type-setup-header.component.scss'],
})
export class TripTypeSetupHeaderComponent implements OnChanges {
  tabTitle: string;
  iconTooltip: string;

  @Input() vehicleType: VehicleType;

  ngOnChanges(changes: SimpleChanges): void {
    if ('vehicleType' in changes) {
      this.tabTitle = this.getTabTitle(this.vehicleType);
      this.iconTooltip = this.getIconTooltipText(this.vehicleType);
    }
  }

  private getTabTitle(vehicleType: VehicleType): string {
    switch (vehicleType) {
      case VehicleType.Company:
        return 'TripTypeSetupInformationTab.SetupPersonal';
      case VehicleType.Personal:
        return 'TripTypeSetupInformationTab.SetupBussiness';
      case VehicleType.Corporate:
        return 'TripTypeSetupInformationTab.SetupPersonal';
      default:
        return 'TripTypeSetupInformationTab.VehicleTypeNotRecognized';
    }
  }

  private getIconTooltipText(vehicleType: VehicleType): string {
    switch (vehicleType) {
      case VehicleType.Company:
        return 'TripTypeSetupInformationTab.SetupPersonalTooltip';
      case VehicleType.Personal:
        return 'TripTypeSetupInformationTab.SetupBussinessTooltip';
      case VehicleType.Corporate:
        return 'TripTypeSetupInformationTab.SetupPersonalTooltip';
      default:
        return '';
    }
  }
}
